<script>
import Loader from "@/components/widgets/loader";

/**
 * Weekly-Earning component
 */
export default {
   components: {
      Loader,
   },
   data() {
      return {
         decreaseChartOptions: {
            chart: {
               height: 200,
               type: "radialBar",
               offsetY: -10,
            },
            plotOptions: {
               radialBar: {
                  startAngle: -135,
                  endAngle: 135,
                  dataLabels: {
                     name: {
                        fontSize: "13px",
                        color: undefined,
                        offsetY: 60,
                     },
                     value: {
                        offsetY: 30,
                        fontSize: "16px",
                        color: undefined,
                        formatter: function (val) {
                           return val + "%";
                        },
                     },
                  },
               },
            },
            colors: ["#f46a6a"],
            fill: {
               type: "gradient",
               gradient: {
                  shade: "dark",
                  shadeIntensity: 0.15,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 50, 65, 30],
               },
            },
            stroke: {
               dashArray: 4,
            },
            labels: ["decrease"],
         },

         increaseChartOptions: {
            chart: {
               height: 200,
               type: "radialBar",
               offsetY: -10,
            },
            plotOptions: {
               radialBar: {
                  startAngle: -135,
                  endAngle: 135,               
                  dataLabels: {
                     name: {
                        fontSize: "13px",
                        color: undefined,
                        offsetY: 60,
                     },
                     value: {
                        offsetY: 30,
                        fontSize: "16px",
                        color: undefined,
                        formatter: function (val) {
                           return val + "%";
                        },
                     },
                  },
               },
            },
            colors: ["#34c38f"],
            fill: {
               type: "gradient",
               gradient: {
                  shade: "dark",
                  shadeIntensity: 0.15,
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 50, 65, 30],
               },
            },
            stroke: {
               dashArray: 4,
            },
            labels: ["increase"],
         },

      };

   },

   props: {
      updating: {
         type: Boolean,
      },
      weekly_data: {
         type: Object,
         default: () => {
            return { 
               weekly_decrease: null,
               weekly_earnings: 0,
               weekly_increase: null,
               series: [],
            }
         },
      }
   },

};
</script>

<template>
   <Loader :loading="updating">
      <div class="card">
         <div class="card-body">
            <h4 class="card-title mb-4">Weekly Collection</h4>
            <div class="row">
               <div class="col-sm-6">
                  <p class="text-muted">This Week</p>
                  <h3>Rs. {{weekly_data.weekly_earnings}}</h3>
                  <p class="text-muted">
                     <span v-if="weekly_data.weekly_increase" class="text-success me-2">
                        {{weekly_data.weekly_increase}}%
                        <i class="mdi mdi-arrow-up"></i>
                     </span>
                     <span v-else-if="weekly_data.weekly_decrease" class="text-danger me-2">
                        {{weekly_data.weekly_decrease}}%
                        <i class="mdi mdi-arrow-down"></i>
                     </span>
                     <span v-else class="text-primary me-2">0%</span>
                     From previous week
                  </p>

               </div>
               <div class="col-sm-6">
                  <!-- Chart -->
                  <apexchart  v-if="weekly_data.weekly_decrease >= 0 && weekly_data.weekly_increase == 0"
                     class="apex-charts"
                     type="radialBar"
                     height="200"
                     dir="ltr"
                     :series="weekly_data.series"
                     :options="decreaseChartOptions"
                  ></apexchart>
                  <apexchart  v-if="weekly_data.weekly_increase > 0"
                     class="apex-charts"
                     type="radialBar"
                     height="200"
                     dir="ltr"
                     :series="weekly_data.series"
                     :options="increaseChartOptions"
                  ></apexchart>
               </div>
            </div>
            <!-- <p class="text-muted mb-0">
               We craft digital, graphic and dimensional thinking.
            </p> -->
         </div>
      </div>
   </Loader>
</template>